import axiosInstance from "@/services/axiosInterceptor";

export async function sessionsRecordings(studentId = null) {
  try {
    let response;

    if (studentId) {
      response = await axiosInstance.get(`users/sessions-recordings?studentId=${studentId}`);
    } else {
      response = await axiosInstance.get(`users/sessions-recordings`);
    }

    const data = response.data;
    return data;
  } catch (error) {
    throw error;
  }
}
